import type { ExpressionSpecification } from "maplibre-gl";
import { pick, type LayerStyle } from "./types";

// Extruded from z15 only (design D6): below it the tiles drop footprints and mobile GPUs suffer.
export const EXTRUDE_MINZOOM = 15;
export const FEET_TO_METRES = 0.3048;
const BUILDING = "#797d85";

/** `buildingheight` is in feet; missing or bad values extrude to 0. Mirrors HEIGHT below. */
export function heightMetres(buildingheight: unknown): number {
  const ft = Number(buildingheight);
  return Number.isFinite(ft) && ft > 0 ? ft * FEET_TO_METRES : 0;
}

export const HEIGHT: ExpressionSpecification = ["*", ["max", 0, ["coalesce", ["to-number", ["get", "buildingheight"], 0], 0]], FEET_TO_METRES];

const style: LayerStyle = {
  id: "txgio-footprints",
  minzoom: EXTRUDE_MINZOOM,
  maxzoom: 16,
  layers(source) {
    return [
      {
        id: `${this.id}:extrusion`,
        type: "fill-extrusion",
        source,
        "source-layer": this.id,
        minzoom: EXTRUDE_MINZOOM,
        paint: {
          "fill-extrusion-color": BUILDING,
          "fill-extrusion-height": HEIGHT,
          "fill-extrusion-base": 0,
          "fill-extrusion-opacity": 0.85,
        },
      },
    ];
  },
  legend: [{ label: "Building, height from lidar (from zoom 15)", color: BUILDING }],
  describe: (p) =>
    pick(p, [
      ["buildingheight", "Height", (v) => `${Math.round(Number(v))} ft (${heightMetres(v).toFixed(1)} m)`],
      ["sourceyear", "Lidar year"],
      ["county", "County"],
    ]),
};

export default style;
